import React, { Component } from "react";
import InputField from "./Elements/InputField";
import SubmitFeed from "./Elements/SubmitFeed";


class RssFeed extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userBoard: "",
            url: "",
            error: false,
            urlError: false,
            loading: false
        }
    }

    onTextChange = (e) => this.setState({ [e.target.name]: e.target.value, error: false, urlError: false });

    onSubmit = () => {
        const { updateStep } = this.props;
        const { userBoard, url } = this.state;

        if (!userBoard || userBoard == ""){
            this.setState({ error: true })
        }
        if (!url || url == ""){
            this.setState({ urlError: true })
        }
        else {
            var obj = {
                networkId: 12,
                filter: 13,
                fieldtitle: userBoard,
                moderation: 0
            }

            if (!url.includes("://")) {
                this.setState({ urlError: true });
                return;
            } else {
                obj['field'] = url;
            }

            this.setState({ error: false, urlError: false, loading: true });

            updateStep(2, obj, () => this.setState({ loading: false }));
        }
    }

    render() {
        const { userBoard, url, error, urlError, loading } = this.state;

        return (
            <div className="ob-feed-form-wrapper w-100">
                <div className="selectSource-right mb-3">
                    <label className="text-start d-block mb-0">Display Name</label>
                    <div className="position-relative advance-input custom-input">
                        <div className="position-relative d-flex">
                            <span className="hastag d-flex align-items-center">
                                <i className={`fas fa-font`}></i>
                            </span>
                            <InputField name={"userBoard"} placeholder="Enter display name here.." className="form-control p-3" value={userBoard} onChangeHandler={(e) => this.onTextChange(e)} />
                        </div>
                    </div>
                    {error && <span id="feedsslackkeyworderror" className="errorMessage required text-start">This field is required</span>}
                </div>

                <div className="selectSource-right mb-3">
                   <label className="text-start d-block mb-0">Feed Url</label>
                    <div className="position-relative advance-input custom-input">
                        <div className="position-relative d-flex">
                            <span className="hastag d-flex align-items-center">
                                <i className={`fas fa-link`}></i>
                            </span>
                            <InputField name={"url"} placeholder="Enter RSS feed URL here.." className="form-control p-3" value={url} onChangeHandler={(e) => this.onTextChange(e)} />
                        </div>
                    </div>
                    {urlError && <span id="feedsslackkeyworderror" className="errorMessage required text-start">This field must contain a url</span>}
                </div>
                <div className="click-next d-flex align-items-center justify-content-between py-3 px-4 rounded">
                    <SubmitFeed loading={loading} onSubmit={this.onSubmit} onBack={this.props.backAction} disabled={!userBoard.trim() || !url.trim()} />
                </div>
            </div>
        )
    }
}

export default RssFeed;